module.exports = __webpack_public_path__ + "platform/static/media/bidd-first-bg.827cf0e6.webp";